// export const getUserRole = () => {
//   return localStorage.getItem("role");
// };
// export const getAdminData = () => {
//   const admin = localStorage.getItem("admin");
//   return admin ? JSON.parse(admin) : null;
// };
export const getUserRole = () => {
  const role = localStorage.getItem("role");
  return typeof role === "string" ? role.toLowerCase() : "";
};

export const getAdminData = () => {
  try {
    const admin = localStorage.getItem("admin");
    return admin ? JSON.parse(admin) : null;
  } catch {
    return null;
  }
};

export const isVendorAdmin = () => {
  const role = getUserRole();
  return role === "vender" || role === "vendor";
};

export const isStaff = () => {
  const role = getUserRole();
  return role === "staff" || role === "employee";
};
export const getLoginType = () => {
  const type = localStorage.getItem("login_type");
  if (!type) return "unknown";
  return type.toLowerCase();
};



export const isStaffByLoginType = () => {
  return getLoginType() === "staff";
};
export const isVisitAllowedUser = () => {
  const adminData = getAdminData();
  if (!adminData) return false;
  const vendorId = adminData.user_id || adminData.vendor_id;
  return vendorId === "VND-330792";
};

const lastTenDigits = (value) =>
  String(value || "").replace(/\D/g, "").slice(-10);

export const SPLIT_LEAD_VENDOR_MOBILE = "9610311606";

export const isSplitLeadVendor = () => {
  const adminData = getAdminData();
  if (!adminData) return false;

  const mobiles = [
    adminData.mobile,
    adminData.phone,
    adminData.vendor_mobile,
    adminData.vendor?.mobile,
    adminData.vendor?.phone,
  ];

  return mobiles.some(
    (value) => lastTenDigits(value) === SPLIT_LEAD_VENDOR_MOBILE
  );
};

export const normalizeLeadType = (value) => {
  const type = String(value || "").toLowerCase();
  if (type === "work" || type === "investment") return type;
  return "";
};

export const activeLeadType = (searchValue) => {
  if (!isSplitLeadVendor()) return "";
  return normalizeLeadType(searchValue);
};

const readLeadType = (lead) =>
  lead?.lead_type ?? lead?.leadType ?? lead?.type ?? "";

export const isHiddenVendorTestLead = (lead) =>
  String(lead?.name || "").toLowerCase().includes("luxury car rental miami_elon");

export const filterLeadsByType = (leads, leadType) => {
  if (!leadType) return leads;
  const list = Array.isArray(leads) ? leads : [];
  const hasTypedLead = list.some((lead) => readLeadType(lead));
  if (!hasTypedLead) return list;
  return list.filter(
    (lead) => String(readLeadType(lead)).toLowerCase() === leadType
  );
};

export const rowsForVendorList = (leads, leadType, status) => {
  let list = Array.isArray(leads) ? leads : [];
  if (status) {
    list = list.filter(
      (lead) => String(lead?.status || "").toLowerCase() === String(status).toLowerCase()
    );
  }
  if (!isSplitLeadVendor()) {
    return leadType ? filterLeadsByType(list, leadType) : list;
  }
  list = list.filter((lead) => !isHiddenVendorTestLead(lead));
  if (!leadType) return list;
  return list.filter(
    (lead) => String(readLeadType(lead)).toLowerCase() === leadType
  );
};

export const vendorCallResultLabel = (value) => {
  const key = String(value || "").trim().toLowerCase().replace(/[\s-]+/g, "_");
  const labels = {
    timeout: "No Response",
    busy: "No Response",
    failed: "No Response",
    no_answer: "No Response",
    no_response: "No Response",
    interested: "Interested",
    not_interested: "Not Interested",
    callback_requested: "Callback Requested",
    completed: "Completed",
    pending: "Pending",
  };
  return labels[key] || (value ? String(value).replaceAll("_", " ") : "-");
};

export const formatTalkTime = (value) => {
  const total = Math.max(0, Number(value) || 0);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  return `${total.toLocaleString("en-IN")} sec (${hours}h ${minutes}m ${seconds}s)`;
};

export const formatVisitDay = (value) => {
  if (!value) return "";
  const parsed = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return String(value);
  return parsed.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const leadTypeLabel = (leadType) => {
  if (leadType === "work") return "Work";
  if (leadType === "investment") return "Investment";
  return "";
};

const firstFilled = (sources, keys) => {
  for (const source of sources) {
    if (!source || typeof source !== "object") continue;
    for (const key of keys) {
      const value = source[key];
      if (value != null && String(value).trim() !== "") return String(value).trim();
    }
  }
  return "";
};

const splitDateTime = (value) => {
  const text = String(value || "").trim();
  const match = text.match(/^(\d{4}-\d{2}-\d{2})[T\s](\d{2}:\d{2}(?::\d{2})?)/);
  if (match) return { date: match[1], time: match[2].slice(0, 5) };
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return { date: text, time: "" };
  if (/^\d{2}:\d{2}/.test(text)) return { date: "", time: text.slice(0, 5) };
  return { date: "", time: text };
};

export const callbackListRows = (response) => {
  const pools = [
    response,
    response?.data,
    response?.api_response,
    response?.data?.api_response,
  ];
  const listKeys = [
    "callbacks",
    "callback",
    "leads",
    "calls",
    "data",
    "records",
    "items",
    "results",
    "callback_list",
  ];
  for (const pool of pools) {
    if (Array.isArray(pool)) return pool;
    if (!pool || typeof pool !== "object") continue;
    for (const key of listKeys) {
      if (Array.isArray(pool[key])) return pool[key];
    }
  }
  return [];
};

export const presentCallback = (item) => {
  const sources = [item, item?.user, item?.lead, item?.customer, item?.callback];
  const name = firstFilled(sources, ["name", "customer_name", "user_name", "lead_name", "full_name"]);
  const number = firstFilled(sources, [
    "phone",
    "mobile",
    "number",
    "contact_number",
    "user_number",
    "callback_number",
    "contact",
  ]);
  let date = firstFilled(sources, ["date", "callback_date", "preferred_date", "contact_date", "visit_date"]);
  let time = firstFilled(sources, ["time", "callback_time", "preferred_time", "contact_time", "call_time", "visit_time"]);
  if (/^\d{4}-\d{2}-\d{2}/.test(time)) {
    const fromTime = splitDateTime(time);
    date = date || fromTime.date;
    time = fromTime.time || time;
  }
  if (!date || !time) {
    const combined = splitDateTime(
      firstFilled(sources, ["callback_at", "called_at", "datetime", "preferred_datetime", "created_at"])
    );
    date = date || combined.date;
    time = time || combined.time;
  }
  const details = firstFilled(sources, ["details", "message", "note", "remark", "comment", "reason"]);
  return {
    name: name || "-",
    number: number || "-",
    date: date ? formatVisitDay(date) || date : "-",
    time: time || "-",
    details: details || "-",
  };
};

export const listPageMeta = (response, visibleCount, perPage) => {
  const nested = response?.data;
  const source =
    nested && !Array.isArray(nested) && nested.total != null
      ? nested
      : response?.meta?.total != null
        ? response.meta
        : response;
  const apiTotal = Number(source?.total);
  const total = Number.isFinite(apiTotal) ? apiTotal : visibleCount;
  const apiLast = Number(source?.last_page);
  const size = Math.max(1, Number(perPage) || 1);
  const pages =
    Number.isFinite(apiLast) && apiLast > 0
      ? apiLast
      : Math.max(1, Math.ceil(total / size));
  return {
    total,
    pages,
    page: Number(source?.current_page) || 1,
  };
};